import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const AktienTrendsServiceConfig = {
  name: "AktienTrends",
  annotations: []
} as ServiceConfig;